import { selectionSet, type BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import type { AppliedContract } from '../entities/AppliedContract.js';
import { ContractSupplement } from '../entities/ContractSupplement.js';
import { AGInfos } from '../entities/vertrag-sektionen/AGinfos.js';
import { AGSozialVersicherung } from '../entities/vertrag-sektionen/AGSozialversicherung.js';
import {
  AGEingruppierung1,
  AGEingruppierung2,
} from '../entities/vertrag-sektionen/vertrag-eingruppierung/AGEingruppierung.js';

export const CONTRACT_DOCUMENT_SELECTIONSET = {
  userID: 1,
  appliedDate: 1,
  agInfos: selectionSet(() => AGInfos, 1),
  agSozialVersicherung: selectionSet(() => AGSozialVersicherung, 1),
  agEingruppierung1: selectionSet(() => AGEingruppierung1, 5),
  agEingruppierung2: selectionSet(() => AGEingruppierung2, 5),
  supplements: selectionSet(() => ContractSupplement, 2),
} satisfies BaseQLSelectionSet<AppliedContract>;
